import { Box } from "@mui/material";
import React from "react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const SuccessIcon = () => {
  return (
    <Box
      component={CheckCircleIcon}
      sx={{
        width: "30px",
        fontSize: "20px",
        mr: "10px",
        alignSelf: "flex-start",
        color: "green",
      }}
    />
  );
};
export default SuccessIcon;
